import React, { useState, useEffect, useRef } from 'react';

export default function MessageDebugPanel({ messages, onClose }) {
  const bottomRef = useRef(null);
  const [filter, setFilter] = useState('all');
  const [fullscreen, setFullscreen] = useState(false);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const filtered = filter === 'all' ? messages : messages.filter(m => m.dir === filter);

  return (
    <div style={{
      position: 'fixed',
      bottom: 0, right: 0,
      top: fullscreen ? 0 : 'auto',
      left: fullscreen ? 0 : 'auto',
      width: fullscreen ? '100%' : '420px',
      height: fullscreen ? '100%' : 'auto',
      maxHeight: fullscreen ? '100%' : '50vh',
      background: '#1E1E2E', color: '#CDD6F4', fontFamily: 'monospace', fontSize: '12px',
      borderTopLeftRadius: fullscreen ? 0 : '8px',
      boxShadow: fullscreen ? 'none' : '0 -2px 20px rgba(0,0,0,0.4)',
      zIndex: 99999,
      display: 'flex', flexDirection: 'column', overflow: 'hidden',
    }}>
      <div style={{
        padding: '8px 12px', background: '#313244', display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', borderBottom: '1px solid #45475A', flexShrink: 0,
      }}>
        <span style={{ fontWeight: 700, color: '#F5C2E7' }}>postMessage Debug</span>
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
          {['all', 'out', 'in'].map(f => (
            <button key={f} onClick={() => setFilter(f)} style={{
              padding: '2px 8px', borderRadius: '4px', border: 'none', cursor: 'pointer',
              background: filter === f ? '#89B4FA' : '#45475A',
              color: filter === f ? '#1E1E2E' : '#BAC2DE', fontSize: '11px', fontWeight: 600,
            }}>{f === 'out' ? 'Sent' : f === 'in' ? 'Received' : 'All'}</button>
          ))}
          <button onClick={() => setFullscreen(f => !f)} style={{
            background: 'none', border: 'none', cursor: 'pointer', color: '#6C7086',
            fontSize: '13px', padding: '0 4px', lineHeight: 1,
          }} title={fullscreen ? 'Minimize' : 'Maximize'}>{fullscreen ? '⊖' : '⊕'}</button>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', cursor: 'pointer', color: '#6C7086',
            fontSize: '16px', padding: '0 2px', lineHeight: 1,
          }} title="Close">✕</button>
        </div>
      </div>
      <div style={{ overflowY: 'auto', padding: '6px 10px', flex: 1 }}>
        {filtered.length === 0 && (
          <div style={{ color: '#6C7086', padding: '12px', textAlign: 'center' }}>No messages yet</div>
        )}
        {filtered.map((m, i) => (
          <div key={i} style={{
            padding: '6px 8px', marginBottom: '4px', borderRadius: '4px',
            background: m.dir === 'out' ? '#1E3A5F' : '#2D1F3D',
            borderLeft: `3px solid ${m.dir === 'out' ? '#89B4FA' : '#F5C2E7'}`,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
              <span style={{ color: m.dir === 'out' ? '#89B4FA' : '#F5C2E7', fontWeight: 600 }}>
                {m.dir === 'out' ? '→ SENT' : '← RECV'} {m.type || '?'}
              </span>
              <span style={{ color: '#6C7086', fontSize: '10px' }}>{m.time}</span>
            </div>
            <pre style={{
              margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all',
              color: '#A6ADC8', fontSize: '11px', overflow: 'auto',
            }}>{m.preview}</pre>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>
    </div>
  );
}
